import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type { PassType } from "../models/PassType";

// ============================================
// PASS TYPES
// ============================================

export interface GetPassTypesParams {
	id?: number | null;
	onlyActives?: boolean;
}

export const getPassTypes = async (
	params: GetPassTypesParams = {},
): Promise<PassType[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "Id", value: params.id ?? null },
		{ name: "OnlyActives", value: params.onlyActives ?? true },
	];

	const resp = await apiService.callV2("[MILL].[GetPassTypes]", parameters);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as PassType[];
	}
	throw new Error(resp.message || "Error fetching pass types");
};

export const upsertPassType = async (passType: PassType): Promise<PassType> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "Id", value: passType.Id },
		{ name: "Name", value: passType.Name },
		{ name: "Description", value: passType.Description },
		{ name: "Active", value: passType.Active },
	];

	const resp = await apiService.callV2("[MILL].[UpsertPassType]", parameters);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows[0]", null) as PassType;
	}
	throw new Error(resp.message || "Error saving pass type");
};

export const deletePassType = async (passTypeId: number): Promise<void> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "Id", value: passTypeId }];

	const resp = await apiService.callV2("[MILL].[RemovePassType]", parameters);

	if (!resp.ok) {
		throw new Error(resp.message || "Error deleting pass type");
	}
};
